module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjMwMSIgdmlld0JveD0iMCAwIDMwMSAzMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSJyZWQiIGQ9Ik0uNS41aDMwMHYzMDBILjV6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTU2Ljc1IDEyMi4zNzVoMTg3LjV2NTYuMjVINTYuNzV6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEyMi4zNzUgNTYuNzVoNTYuMjV2MTg3LjVoLTU2LjI1eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-ch.svg
// module id = wiVa
// module chunks = 2